import React from "react";
import { useQuery } from "@apollo/client";
import queries from "Shared/queries";
import {
  GetPayrollAnomalyOutliersQuery,
  GetPayrollAnomalyOutliersQueryVariables,
} from "generated/graphql";

export const PAYROLL_ANOMALIES_PER_PAGE = 10;

export const usePayrollAnomalyOutliers = (netEarningsFileId: string) => {
  const [page, setPage] = React.useState(1);

  const { data, loading } = useQuery<
    GetPayrollAnomalyOutliersQuery,
    GetPayrollAnomalyOutliersQueryVariables
  >(
    queries.GET_PAYROLL_ANOMALY_OUTLIERS,
    {
      variables: {
        id: netEarningsFileId,
        page,
        perPage: PAYROLL_ANOMALIES_PER_PAGE,
      },
    }
  );

  const handlePageChange = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    page: number
  ) => {
    setPage(page);
  };

  return {
    payrollAnomalyOutliers: data?.payrollJournalFile?.anomalyReport?.outliers,
    page,
    rowsPerPage: PAYROLL_ANOMALIES_PER_PAGE,
    handlePageChange,
    loading,
  };
};

